/**
 * Privilege ID
 *
 * @不可手动修改 !!!
 *
 * @更新日期 2023-07-19 13:36:52
 *
 * @如何更新
 * npm run privilege
 *
 * @命名规则
 *  规则1：module.functional.object.operate
 *  规则2：module.functional.operate
 *
 *  CRM 前端读取 Key 的格式除了“用户身份权限” -> ['crm.admin', 'crm.user']
 *  其他权限会去掉 crm 前缀，并统一使用驼峰命名
 *
 * @example
 *  CRM 线索管理->查看线索，crm.lead.private.view
 *             ->创建线索，crm.lead.private.create
 *
 *  CRM 产品->产品管理，crm.setting.product.manage
 *
 *  CRM 邮件->邮箱绑定，crm.setting.email.manage
 *          ->邮件模板，crm.setting.email.template
 *         ->邮件审批，crm.setting.email.review
 *
 *  DX 我的关注，dx.attention.read
 *     取消关注，dx.attention.cancel
 */

/**
 * crm.functional.speechcraft
 */
export const functionalSpeechcraft = 'crm.functional.speechcraft'

/**
 * 谈单指南-话术--查看公司话术
 */
export const speechcraftView = 'crm.speechcraft.view'

/**
 * 谈单指南-话术--创建公司话术
 */
export const speechcraftCreate = 'crm.speechcraft.create'

/**
 * 谈单指南-话术--编辑公司话术
 */
export const speechcraftEdit = 'crm.speechcraft.edit'

/**
 * 谈单指南-话术--删除公司话术
 */
export const speechcraftRemove = 'crm.speechcraft.remove'

/**
 * 谈单指南-话术--下属话术
 */
export const speechcraftSubordinate = 'crm.speechcraft.subordinate'

/**
 * crm.functional.document
 */
export const functionalDocument = 'crm.functional.document'

/**
 * 谈单指南-文档--查看公司文档
 */
export const documentView = 'crm.document.view'

/**
 * 谈单指南-文档--创建公司文档
 */
export const documentCreate = 'crm.document.create'

/**
 * 谈单指南-文档--编辑公司文档
 */
export const documentEdit = 'crm.document.edit'

/**
 * 谈单指南-文档--删除公司文档
 */
export const documentRemove = 'crm.document.remove'

/**
 * crm.functional.suggestion
 */
export const functionalSuggestion = 'crm.functional.suggestion'

/**
 * 谈单指南-建议--编辑建议
 */
export const suggestionEdit = 'crm.suggestion.edit'

/**
 * CRM模块
 */
export const functionalBase = 'crm.functional.base'

/**
 * 设置管理--邮箱绑定
 */
export const settingEmailManage = 'crm.setting.email.manage'

/**
 * 设置管理--邮件模板
 */
export const settingEmailTemplate = 'crm.setting.email.template'

/**
 * 设置管理--邮件审批
 */
export const settingEmailReview = 'crm.setting.email.review'

/**
 * 设置管理--客户设置
 */
export const settingCustomerManage = 'crm.setting.customer.manage'

/**
 * 设置管理--公司标签
 */
export const settingCustomerClientTagManage =
  'crm.setting.customer.client.tag.manage'

/**
 * 设置管理--客户导出
 */
export const settingCustomerExport = 'crm.setting.customer.export'

/**
 * 设置管理--产品设置
 */
export const settingProductManage = 'crm.setting.product.manage'

/**
 * 设置管理--报价单设置
 */
export const settingQuotationManage = 'crm.setting.quotation.manage'

/**
 * 设置管理--销售订单设置
 */
export const settingOrderManage = 'crm.setting.order.manage'

/**
 * 设置管理--报关设置
 */
export const settingCustomsManage = 'crm.setting.customs.manage'

/**
 * 设置管理--营销设置
 */
export const settingEdm = 'crm.setting.edm'

/**
 * 设置管理--汇率设置
 */
export const settingExchangeManage = 'crm.setting.exchange.manage'

/**
 * 设置管理--自定义报表
 */
export const settingStatisticManage = 'crm.setting.statistic.manage'

/**
 * 设置管理--通讯录设置
 */
export const settingContactsManage = 'crm.setting.contacts.manage'

/**
 * 设置管理--设置特殊审批人
 */
export const settingEmailReviewSpecify = 'crm.setting.email.review.specify'

/**
 * 设置管理--谈单指南设置
 */
export const settingSalesGuide = 'crm.setting.sales.guide'

/**
 * 设置管理--来源设置
 */
export const settingOriginManage = 'crm.setting.origin.manage'

/**
 * 设置管理--功能开关
 */
export const settingModuleManage = 'crm.setting.module.manage'

/**
 * 设置管理--字段设置
 */
export const settingFieldsManage = 'crm.setting.fields.manage'

/**
 * 设置管理--商机设置
 */
export const settingOpportunityManage = 'crm.setting.opportunity.manage'

/**
 * 设置管理--评分设置
 */
export const settingAssessDimensionManage =
  'crm.setting.assess.dimension.manage'

/**
 * 设置管理--PayPal收款
 */
export const settingPaypalManage = 'crm.setting.paypal.manage'

/**
 * 设置管理--Alibaba.com Pay
 */
export const settingAcpManage = 'crm.setting.acp.manage'

/**
 * 设置管理--角色权限
 */
export const settingPrivilegeManage = 'crm.setting.privilege.manage'

/**
 * 设置管理--账号关联
 */
export const settingAccountRelation = 'crm.setting.account.relation'

/**
 * 设置管理--成员管理
 */
export const settingUserManage = 'crm.setting.user.manage'

/**
 * 设置管理--账号信息
 */
export const settingAccountInfo = 'crm.setting.account.info'

/**
 * 设置管理--云盘管理
 */
export const settingDiskManage = 'crm.setting.disk.manage'

/**
 * 设置管理--AI 自动化设置
 */
export const aiSetting = 'crm.ai.setting'

/**
 * 设置管理--工作流管理
 */
export const settingWorkflowManage = 'crm.setting.workflow.manage'

/**
 * 设置管理--审批流管理
 */
export const settingApprovalflowManage = 'crm.setting.approvalflow.manage'

/**
 * 设置管理--回收站
 */
export const settingRecycleManage = 'crm.setting.recycle.manage'

/**
 * 设置管理--阿里店铺管理
 */
export const settingAlibabaStoreManage = 'crm.setting.alibaba.store.manage'

/**
 * 设置管理--采购设置
 */
export const settingPurchaseOrderManage = 'crm.setting.purchase.order.manage'

/**
 * 设置管理--供应商设置
 */
export const settingPurchaseSupplierManage =
  'crm.setting.purchase.supplier.manage'

/**
 * 设置管理--允许发件给未建档客户
 */
export const settingMailSendStranger = 'crm.setting.mail.send.stranger'

/**
 * 设置管理--允许发件给同事客户
 */
export const settingMailSendCollegeCustomer =
  'crm.setting.mail.send.college.customer'

/**
 * 设置管理--任务设置
 */
export const settingTaskManage = 'crm.setting.task.manage'

/**
 * 设置管理--采购入库单设置
 */
export const settingPurchaseInboundManage =
  'crm.setting.purchase.inbound.manage'

/**
 * 设置管理--销售出库单设置
 */
export const settingSalesOutboundManage = 'crm.setting.sales.outbound.manage'

/**
 * 设置管理--其他入库单设置
 */
export const settingOtherInboundManage = 'crm.setting.other.inbound.manage'

/**
 * 设置管理--其他出库单设置
 */
export const settingOtherOutboundManage = 'crm.setting.other.outbound.manage'

/**
 * 设置管理--采购退货单设置
 */
export const settingPurchaseReturnManage = 'crm.setting.purchase.return.manage'

/**
 * 设置管理--库存初始化
 */
export const settingInventoryInitManage = 'crm.setting.inventory.init.manage'

/**
 * 设置管理--出入库原因
 */
export const settingInventoryReasonManage =
  'crm.setting.inventory.reason.manage'

/**
 * 设置管理--回款单设置
 */
export const cashCollectionSetting = 'crm.cashCollection.setting'

/**
 * 设置管理--回款登记设置
 */
export const cashCollectionInvoiceSetting = 'crm.cashCollectionInvoice.setting'

/**
 * 设置管理--询盘设置
 */
export const settingCustomerInquiry = 'crm.setting.customer.inquiry'

/**
 * 设置管理--付款单设置
 */
export const settingPaymentInvoiceManage = 'crm.setting.payment.invoice.manage'

/**
 * 设置管理--费用单设置
 */
export const settingCostInvoiceManage = 'crm.setting.cost.invoice.manage'

/**
 * 设置管理--资金账户管理
 */
export const settingCapital_accountManage = 'crm.setting.capital_account.manage'

/**
 * 设置管理--仓库管理
 */
export const settingWarehouseManage = 'crm.setting.warehouse.manage'

/**
 * 设置管理--单据模版设置
 */
export const settingInvoiceExportTemplate =
  'crm.setting.invoice.export.template'

/**
 * 设置管理--费用设置
 */
export const settingFundManage = 'crm.setting.fund.manage'

/**
 * crm.functional.customer
 */
export const functionalCustomer = 'crm.functional.customer'

/**
 * 客户--查看
 */
export const companyPrivateView = 'crm.company.private.view'

/**
 * 客户--创建
 */
export const companyPrivateCreate = 'crm.company.private.create'

/**
 * 客户--编辑
 */
export const companyPrivateEdit = 'crm.company.private.edit'

/**
 * 客户--转移
 */
export const companyPrivateTransfer = 'crm.company.private.transfer'

/**
 * 客户--删除
 */
export const companyPrivateRemove = 'crm.company.private.remove'

/**
 * 客户--重新分配
 */
export const companyPrivateAssign = 'crm.company.private.assign'

/**
 * 客户--移除跟进人
 */
export const companyPrivateReleaseSpecifyUser =
  'crm.company.private.release.specify.user'

/**
 * 客户--取消跟进
 */
export const companyPrivateRelease = 'crm.company.private.release'

/**
 * 客户--共享客户
 */
export const companyPrivateShare = 'crm.company.private.share'

/**
 * 客户--移入公海
 */
export const companyPrivateMovePool = 'crm.company.private.move.pool'

/**
 * 客户--合并客户
 */
export const companyPrivateMerge = 'crm.company.private.merge'

/**
 * 客户--评分
 */
export const companyAssessFirst = 'crm.company.assess.first'

/**
 * 客户--再次评分
 */
export const companyAssessSecond = 'crm.company.assess.second'

/**
 * 客户--查看名片夹
 */
export const companyCardHolderView = 'crm.company.card.holder.view'

/**
 * crm.functional.mail
 */
export const functionalMail = 'crm.functional.mail'

/**
 * 邮件--查看
 */
export const mailView = 'crm.mail.view'

/**
 * 邮件--彻底删除
 */
export const mailHardRemove = 'crm.mail.hard.remove'

/**
 * 邮件--解锁
 */
export const emailApprovalUnlock = 'crm.email.approval.unlock'

/**
 * 邮件--导出
 */
export const mailExport = 'crm.mail.export'

/**
 * 客户公海
 */
export const functionalCompanyPool = 'crm.functional.company.pool'

/**
 * 公海客户--查看
 */
export const companyPoolView = 'crm.company.pool.view'

/**
 * 公海客户--创建
 */
export const companyPoolCreate = 'crm.company.pool.create'

/**
 * 公海客户--编辑
 */
export const companyPoolEdit = 'crm.company.pool.edit'

/**
 * 公海客户--删除
 */
export const companyPoolRemove = 'crm.company.pool.remove'

/**
 * 公海客户--移入私海
 */
export const companyPoolHold = 'crm.company.pool.hold'

/**
 * 公海客户--分配客户
 */
export const companyPoolAssign = 'crm.company.pool.assign'

/**
 * 回款单模块
 */
export const functionalCashCollection = 'crm.functional.cashCollection'

/**
 * 回款单--查看
 */
export const cashCollectionView = 'crm.cashCollection.view'

/**
 * 回款单--创建
 */
export const cashCollectionCreate = 'crm.cashCollection.create'

/**
 * 回款单--编辑
 */
export const cashCollectionEdit = 'crm.cashCollection.edit'

/**
 * 回款单--关联
 */
export const cashCollectionRelate = 'crm.cashCollection.relate'

/**
 * 回款单--取消关联
 */
export const cashCollectionRelateCancel = 'crm.cashCollection.relate.cancel'

/**
 * 回款单--变更状态
 */
export const cashCollectionStatusChange = 'crm.cashCollection.status.change'

/**
 * 回款单--删除
 */
export const cashCollectionRemove = 'crm.cashCollection.remove'

/**
 * 回款单--下载
 */
export const cashCollectionDownload = 'crm.cashCollection.download'

/**
 * crm.functional.cashCollectionInvoice
 */
export const functionalCashCollectionInvoice =
  'crm.functional.cashCollectionInvoice'

/**
 * 回款登记--查看
 */
export const cashCollectionInvoiceView = 'crm.cashCollectionInvoice.view'

/**
 * 回款登记--创建
 */
export const cashCollectionInvoiceCreate = 'crm.cashCollectionInvoice.create'

/**
 * 回款登记--编辑
 */
export const cashCollectionInvoiceEdit = 'crm.cashCollectionInvoice.edit'

/**
 * 回款登记--提交审批
 */
export const cashCollectionInvoiceReview = 'crm.cashCollectionInvoice.review'

/**
 * 回款登记--认领
 */
export const cashCollectionInvoiceConfirm_receive =
  'crm.cashCollectionInvoice.confirm_receive'

/**
 * 回款登记--撤销认领
 */
export const cashCollectionInvoiceCancel_receive =
  'crm.cashCollectionInvoice.cancel_receive'

/**
 * 回款登记--核销
 */
export const cashCollectionInvoiceApportion =
  'crm.cashCollectionInvoice.apportion'

/**
 * 回款登记--删除
 */
export const cashCollectionInvoiceRemove = 'crm.cashCollectionInvoice.remove'

/**
 * 回款登记--下载
 */
export const cashCollectionInvoiceDownload =
  'crm.cashCollectionInvoice.download'

/**
 * 产品模块
 */
export const functionalProduct = 'crm.functional.product'

/**
 * 产品--查看
 */
export const productView = 'crm.product.view'

/**
 * 产品--创建
 */
export const productCreate = 'crm.product.create'

/**
 * 产品--编辑
 */
export const productEdit = 'crm.product.edit'

/**
 * 产品--删除
 */
export const productDelete = 'crm.product.delete'

/**
 * 产品--编辑产品编号(新建产品)
 */
export const productEditNoCreate = 'crm.product.edit.no.create'

/**
 * 产品--编辑产品编号(编辑产品)
 */
export const productEditNoUpdate = 'crm.product.edit.no.update'

/**
 * 产品--产品批量下载
 */
export const productExport = 'crm.product.export'

/**
 * crm.functional.platform.product
 */
export const functionalPlatformProduct = 'crm.functional.platform.product'

/**
 * 平台产品--查看
 */
export const platformProductView = 'crm.platform.product.view'

/**
 * 平台产品--匹配
 */
export const platformProductMatch = 'crm.platform.product.match'

/**
 * 平台产品--移除
 */
export const platformProductDelete = 'crm.platform.product.delete'

/**
 * 统计分析模块
 */
export const functionalStatistic = 'crm.functional.statistic'

/**
 * 统计分析--查看
 */
export const statisticsView = 'crm.statistics.view'

/**
 * 统计分析--导出报表详情
 */
export const statisticsExport = 'crm.statistics.export'

/**
 * 目标模块
 */
export const functionalPerformance = 'crm.functional.performance'

/**
 * 目标--查看绩效目标
 */
export const performanceView = 'crm.performance.view'

/**
 * 目标--编辑目标值
 */
export const performanceCreate = 'crm.performance.create'

/**
 * 目标--查看团队墙
 */
export const performanceTeamWall = 'crm.performance.team.wall'

/**
 * 目标--目标管理
 */
export const performanceSetting = 'crm.performance.setting'

/**
 * 销售订单
 */
export const functionalOrder = 'crm.functional.order'

/**
 * 销售订单--查看
 */
export const orderView = 'crm.order.view'

/**
 * 销售订单--创建
 */
export const orderCreate = 'crm.order.create'

/**
 * 销售订单--编辑
 */
export const orderEdit = 'crm.order.edit'

/**
 * 销售订单--变更
 */
export const orderConfirmEdit = 'crm.order.confirm.edit'

/**
 * 销售订单--导出
 */
export const orderExport = 'crm.order.export'

/**
 * 销售订单--删除
 */
export const orderRemove = 'crm.order.remove'

/**
 * 销售订单--编辑订单编号(新建销售订单)
 */
export const orderEditNoCreate = 'crm.order.edit.no.create'

/**
 * 销售订单--编辑订单编号(编辑销售订单)
 */
export const orderEditNoEdit = 'crm.order.edit.no.edit'

/**
 * 销售订单--销售订单批量下载
 */
export const settingOrderExport = 'crm.setting.order.export'

/**
 * 销售订单--解锁
 */
export const orderApprovalUnlock = 'crm.order.approval.unlock'

/**
 * 销售订单--生成采购订单
 */
export const orderTo_purchase = 'crm.order.to_purchase'

/**
 * 销售订单--生成销售出库单
 */
export const orderGenerateOutbound = 'crm.order.generate.outbound'

/**
 * 销售订单--确认备妥
 */
export const orderLinkReady_complete = 'crm.order.link.ready_complete'

/**
 * 销售订单--确认出全
 */
export const orderLinkShipment_finish = 'crm.order.link.shipment_finish'

/**
 * 销售订单--确认完成
 */
export const orderLinkFinish = 'crm.order.link.finish'

/**
 * 销售订单--取消完成
 */
export const orderLinkCancel_complete = 'crm.order.link.cancel_complete'

/**
 * 销售订单--计算毛利
 */
export const orderCalculate_gross_profit = 'crm.order.calculate_gross_profit'

/**
 * 销售订单--添加费用单
 */
export const orderTo_cost_invoice = 'crm.order.to_cost_invoice'

/**
 * 销售订单--批量变更状态
 */
export const orderBatch_change_status = 'crm.order.batch_change_status'

/**
 * 销售订单--批量成员管理
 */
export const orderBatch_change_handler = 'crm.order.batch_change_handler'

/**
 * 销售订单--批量录入订单产品
 */
export const orderProductBatch_import = 'crm.order.product.batch_import'

/**
 * 销售订单--订单批量导入
 */
export const orderBatch_import = 'crm.order.batch_import'

/**
 * 报关
 */
export const functionalCustoms = 'crm.functional.customs'

/**
 * 报关--查看
 */
export const customsView = 'crm.customs.view'

/**
 * 报价单
 */
export const functionalQuotation = 'crm.functional.quotation'

/**
 * 报价单--查看
 */
export const quotationView = 'crm.quotation.view'

/**
 * 报价单--创建
 */
export const quotationCreate = 'crm.quotation.create'

/**
 * 报价单--编辑
 */
export const quotationEdit = 'crm.quotation.edit'

/**
 * 报价单--删除
 */
export const quotationRemove = 'crm.quotation.remove'

/**
 * 报价单--报价单批量下载
 */
export const settingQuotationExport = 'crm.setting.quotation.export'

/**
 * 报价单--解锁
 */
export const quotationApprovalUnlock = 'crm.quotation.approval.unlock'

/**
 * 线索模块
 */
export const functionalLead = 'crm.functional.lead'

/**
 * 线索--查看
 */
export const leadPrivateView = 'crm.lead.private.view'

/**
 * 线索--创建
 */
export const leadPrivateCreate = 'crm.lead.private.create'

/**
 * 线索--删除
 */
export const leadPrivateRemove = 'crm.lead.private.remove'

/**
 * 线索--编辑
 */
export const leadPrivateEdit = 'crm.lead.private.edit'

/**
 * 线索--转移
 */
export const leadPrivateTransfer = 'crm.lead.private.transfer'

/**
 * 线索--转化
 */
export const leadPrivateTransform = 'crm.lead.private.transform'

/**
 * 线索--移入公海
 */
export const leadMovePool = 'crm.lead.move.pool'

/**
 * 线索--线索导出
 */
export const leadPrivateReport = 'crm.lead.private.report'

/**
 * 线索--合并线索
 */
export const leadPrivateMerge = 'crm.lead.private.merge'

/**
 * 线索--评分
 */
export const leadPrivateAssessFirst = 'crm.lead.private.assess.first'

/**
 * 线索--再次评分
 */
export const leadPrivateAssessSecond = 'crm.lead.private.assess.second'

/**
 * 线索公海
 */
export const functionalLeadPool = 'crm.functional.lead.pool'

/**
 * 线索公海--查看
 */
export const leadPoolView = 'crm.lead.pool.view'

/**
 * 线索公海--创建
 */
export const leadPoolCreate = 'crm.lead.pool.create'

/**
 * 线索公海--删除
 */
export const leadPoolRemove = 'crm.lead.pool.remove'

/**
 * 线索公海--编辑
 */
export const leadPoolEdit = 'crm.lead.pool.edit'

/**
 * 线索公海--转移
 */
export const leadPoolTransfer = 'crm.lead.pool.transfer'

/**
 * 线索公海--转化
 */
export const leadPoolTransform = 'crm.lead.pool.transform'

/**
 * 商机模块
 */
export const functionalOpportunity = 'crm.functional.opportunity'

/**
 * 商机--查看
 */
export const opportunityView = 'crm.opportunity.view'

/**
 * 商机--创建
 */
export const opportunityCreate = 'crm.opportunity.create'

/**
 * 商机--删除
 */
export const opportunityRemove = 'crm.opportunity.remove'

/**
 * 商机--编辑
 */
export const opportunityEdit = 'crm.opportunity.edit'

/**
 * 商机--转移
 */
export const opportunityTransfer = 'crm.opportunity.transfer'

/**
 * 商机--团队成员管理
 */
export const opportunityMemberManage = 'crm.opportunity.member.manage'

/**
 * 商机--添加动态
 */
export const opportunityTrailCreate = 'crm.opportunity.trail.create'

/**
 * 商机--商机批量导出
 */
export const opportunityExport = 'crm.opportunity.export'

/**
 * 商机--解锁
 */
export const opportunityApprovalUnlock = 'crm.opportunity.approval.unlock'

/**
 * 小满发现
 */
export const functionalDx = 'crm.functional.dx'

/**
 * 小满发现--查看小满发现
 */
export const dxUser = 'crm.dx.user'

/**
 * 小满发现--创建线索
 */
export const dxLeadCreate = 'crm.dx.lead.create'

/**
 * 营销模块
 */
export const functionalMk = 'crm.functional.mk'

/**
 * 小满营销--营销邮件
 */
export const edmView = 'crm.edm.view'

/**
 * 小满营销--自动化营销
 */
export const edmAuto = 'crm.edm.auto'

/**
 * 小满营销--营销邮件报告导出
 */
export const edmExport = 'crm.edm.export'

/**
 * crm.functional.socialmedia.interact
 */
export const functionalSocialmediaInteract =
  'crm.functional.socialmedia.interact'

/**
 * 社媒互动--Facebook聊天
 */
export const facebookView = 'crm.facebook.view'

/**
 * 社媒互动--Facebook帖子
 */
export const facebookPostView = 'crm.facebook.post.view'

/**
 * 社媒互动--Facebook Lead表单
 */
export const facebookLeadView = 'crm.facebook.lead.view'

/**
 * 社媒互动--WhatsApp企业版页面入口
 */
export const wabaView = 'crm.waba.view'

/**
 * 社媒互动--WhatsApp企业版账号创建
 */
export const wabaAccountCreate = 'crm.waba.account.create'

/**
 * crm.functional.socialmedia.manage
 */
export const functionalSocialmediaManage = 'crm.functional.socialmedia.manage'

/**
 * 社媒管理--Facebook管理-查看
 */
export const socialmediaView = 'crm.socialmedia.view'

/**
 * 社媒管理--Facebook管理-新增（重新授权）
 */
export const socialmediaEdit = 'crm.socialmedia.edit'

/**
 * 社媒管理--Facebook管理-解绑
 */
export const socialmediaRemove = 'crm.socialmedia.remove'

/**
 * 社媒管理--Facebook管理-分配
 */
export const socialmediaAssign = 'crm.socialmedia.assign'

/**
 * 社媒管理--WhatsApp企业版管理-页面查看
 */
export const wabaManageView = 'crm.waba.manage.view'

/**
 * 社媒管理--WhatsApp企业版管理-模板管理
 */
export const wabaManageTemplate = 'crm.waba.manage.template'

/**
 * 社媒管理--WhatsApp企业版管理-新建号码
 */
export const wabaManagePhoneCreate = 'crm.waba.manage.phone.create'

/**
 * 社媒管理--WhatsApp企业版管理-分配号码
 */
export const wabaManagePhoneAllot = 'crm.waba.manage.phone.allot'

/**
 * 社媒管理--WhatsApp企业版管理-营销设置
 */
export const wabaManageMarketing = 'crm.waba.manage.marketing'

/**
 * 社媒管理--WhatsApp企业版管理-解绑
 */
export const wabaManageAccountUnbind = 'crm.waba.manage.account.unbind'

/**
 * 采购单模块
 */
export const functionalPurchaseOrder = 'crm.functional.purchase.order'

/**
 * 采购订单--查看
 */
export const purchaseOrderView = 'crm.purchase.order.view'

/**
 * 采购订单--创建
 */
export const purchaseOrderCreate = 'crm.purchase.order.create'

/**
 * 采购订单--删除
 */
export const purchaseOrderRemove = 'crm.purchase.order.remove'

/**
 * 采购订单--编辑
 */
export const purchaseOrderEdit = 'crm.purchase.order.edit'

/**
 * 采购订单--变更
 */
export const purchaseOrderChange = 'crm.purchase.order.change'

/**
 * 采购订单--导出
 */
export const purchaseOrderExport = 'crm.purchase.order.export'

/**
 * 采购订单--解锁
 */
export const purchaseOrderApprovalUnlock = 'crm.purchase.order.approval.unlock'

/**
 * 采购订单--下载
 */
export const purchaseOrderDownload = 'crm.purchase.order.download'

/**
 * 采购订单--生成采购入库单
 */
export const purchaseOrderGenerateInbound =
  'crm.purchase.order.generate.inbound'

/**
 * 采购订单--申请付款
 */
export const purchaseOrderPaymentApply = 'crm.purchase.order.payment.apply'

/**
 * 采购订单--结束付款
 */
export const purchaseOrderPaymentClose = 'crm.purchase.order.payment.close'

/**
 * 采购订单--继续付款
 */
export const purchaseOrderPaymentContinue =
  'crm.purchase.order.payment.continue'

/**
 * 采购订单--添加费用单
 */
export const purchaseOrderTo_cost_invoice = 'crm.purchase.order.to_cost_invoice'

/**
 * 采购订单--批量变更状态
 */
export const purchaseOrderBatch_set_status =
  'crm.purchase.order.batch_set_status'

/**
 * 采购订单--批量变更处理人
 */
export const purchaseOrderBatch_change_handler =
  'crm.purchase.order.batch_change_handler'

/**
 * 供应商模块
 */
export const functionalPurchaseSupplier = 'crm.functional.purchase.supplier'

/**
 * 供应商--查看
 */
export const supplierView = 'crm.supplier.view'

/**
 * 供应商--创建
 */
export const supplierCreate = 'crm.supplier.create'

/**
 * 供应商--删除
 */
export const supplierRemove = 'crm.supplier.remove'

/**
 * 供应商--编辑
 */
export const supplierEdit = 'crm.supplier.edit'

/**
 * 供应商--管理供应产品
 */
export const supplierProduct = 'crm.supplier.product'

/**
 * 供应商--导出
 */
export const supplierExport = 'crm.supplier.export'

/**
 * 以销定购模块
 */
export const functionalPurchase_by_order = 'crm.functional.purchase_by_order'

/**
 * 以销定购--查看
 */
export const purchase_by_orderView = 'crm.purchase_by_order.view'

/**
 * 以销定购--生成采购订单
 */
export const purchase_by_orderCreate = 'crm.purchase_by_order.create'

/**
 * crm.functional.purchase.inbound
 */
export const functionalPurchaseInbound = 'crm.functional.purchase.inbound'

/**
 * 采购入库单--查看
 */
export const purchaseInboundView = 'crm.purchase.inbound.view'

/**
 * 采购入库单--创建
 */
export const purchaseInboundCreate = 'crm.purchase.inbound.create'

/**
 * 采购入库单--删除
 */
export const purchaseInboundRemove = 'crm.purchase.inbound.remove'

/**
 * 采购入库单--编辑
 */
export const purchaseInboundEdit = 'crm.purchase.inbound.edit'

/**
 * 采购入库单--确认入库
 */
export const purchaseInboundConfirm = 'crm.purchase.inbound.confirm'

/**
 * 采购入库单--导出
 */
export const purchaseInboundPrint = 'crm.purchase.inbound.print'

/**
 * crm.functional.other.inbound
 */
export const functionalOtherInbound = 'crm.functional.other.inbound'

/**
 * 其他入库单--查看
 */
export const otherInboundView = 'crm.other.inbound.view'

/**
 * 其他入库单--创建
 */
export const otherInboundCreate = 'crm.other.inbound.create'

/**
 * 其他入库单--删除
 */
export const otherInboundRemove = 'crm.other.inbound.remove'

/**
 * 其他入库单--编辑
 */
export const otherInboundEdit = 'crm.other.inbound.edit'

/**
 * 其他入库单--确认入库
 */
export const otherInboundConfirm = 'crm.other.inbound.confirm'

/**
 * 其他入库单--导出
 */
export const otherInboundPrint = 'crm.other.inbound.print'

/**
 * crm.functional.sales.outbound
 */
export const functionalSalesOutbound = 'crm.functional.sales.outbound'

/**
 * 销售出库单--查看
 */
export const salesOutboundView = 'crm.sales.outbound.view'

/**
 * 销售出库单--创建
 */
export const salesOutboundCreate = 'crm.sales.outbound.create'

/**
 * 销售出库单--删除
 */
export const salesOutboundRemove = 'crm.sales.outbound.remove'

/**
 * 销售出库单--编辑
 */
export const salesOutboundEdit = 'crm.sales.outbound.edit'

/**
 * 销售出库单--确认出库
 */
export const salesOutboundConfirm = 'crm.sales.outbound.confirm'

/**
 * 销售出库单--导出
 */
export const salesOutboundPrint = 'crm.sales.outbound.print'

/**
 * crm.functional.other.outbound
 */
export const functionalOtherOutbound = 'crm.functional.other.outbound'

/**
 * 其它出库单--查看
 */
export const otherOutboundView = 'crm.other.outbound.view'

/**
 * 其它出库单--创建
 */
export const otherOutboundCreate = 'crm.other.outbound.create'

/**
 * 其它出库单--删除
 */
export const otherOutboundRemove = 'crm.other.outbound.remove'

/**
 * 其它出库单--编辑
 */
export const otherOutboundEdit = 'crm.other.outbound.edit'

/**
 * 其它出库单--确认出库
 */
export const otherOutboundConfirm = 'crm.other.outbound.confirm'

/**
 * 其它出库单--导出
 */
export const otherOutboundPrint = 'crm.other.outbound.print'

/**
 * crm.functional.purchase.return
 */
export const functionalPurchaseReturn = 'crm.functional.purchase.return'

/**
 * 采购退货单--查看
 */
export const purchaseReturnView = 'crm.purchase.return.view'

/**
 * 采购退货单--创建
 */
export const purchaseReturnCreate = 'crm.purchase.return.create'

/**
 * 采购退货单--删除
 */
export const purchaseReturnRemove = 'crm.purchase.return.remove'

/**
 * 采购退货单--编辑
 */
export const purchaseReturnEdit = 'crm.purchase.return.edit'

/**
 * 采购退货单--确认退货
 */
export const purchaseReturnConfirm = 'crm.purchase.return.confirm'

/**
 * 采购退货单--导出
 */
export const purchaseReturnPrint = 'crm.purchase.return.print'

/**
 * crm.functional.inventory.flow
 */
export const functionalInventoryFlow = 'crm.functional.inventory.flow'

/**
 * 库存流水--查看
 */
export const inventoryFlowView = 'crm.inventory.flow.view'

/**
 * 库存流水--导出
 */
export const inventoryFlowExport = 'crm.inventory.flow.export'

/**
 * crm.functional.inventory.query
 */
export const functionalInventoryQuery = 'crm.functional.inventory.query'

/**
 * 库存查询--查看
 */
export const inventoryQueryView = 'crm.inventory.query.view'

/**
 * 库存查询--下载
 */
export const inventoryQueryDownload = 'crm.inventory.query.download'

/**
 * crm.functional.payment_invoice
 */
export const functionalPayment_invoice = 'crm.functional.payment_invoice'

/**
 * 付款单--查看
 */
export const payment_invoiceView = 'crm.payment_invoice.view'

/**
 * 付款单--编辑
 */
export const payment_invoiceEdit = 'crm.payment_invoice.edit'

/**
 * 付款单--提交审批
 */
export const payment_invoiceReview = 'crm.payment_invoice.review'

/**
 * 付款单--变更处理人
 */
export const payment_invoiceManageUser = 'crm.payment_invoice.manage.user'

/**
 * 付款单--标记付款
 */
export const payment_invoiceConfirm = 'crm.payment_invoice.confirm'

/**
 * 付款单--下载
 */
export const payment_invoiceExport = 'crm.payment_invoice.export'

/**
 * 付款单--作废
 */
export const payment_invoiceDisable = 'crm.payment_invoice.disable'

/**
 * 付款单--删除
 */
export const payment_invoiceDelete = 'crm.payment_invoice.delete'

/**
 * crm.functional.order.profit
 */
export const functionalOrderProfit = 'crm.functional.order.profit'

/**
 * 订单毛利--查看
 */
export const orderProfitView = 'crm.order.profit.view'

/**
 * 订单毛利--导出
 */
export const orderProfitExport = 'crm.order.profit.export'

/**
 * crm.functional.costInvoice
 */
export const functionalCostInvoice = 'crm.functional.costInvoice'

/**
 * 费用单--查看
 */
export const costInvoiceView = 'crm.costInvoice.view'

/**
 * 费用单--创建
 */
export const costInvoiceCreate = 'crm.costInvoice.create'

/**
 * 费用单--编辑
 */
export const costInvoiceEdit = 'crm.costInvoice.edit'

/**
 * 费用单--申请付款
 */
export const costInvoicePaymentApply = 'crm.costInvoice.payment.apply'

/**
 * 费用单--变更处理人
 */
export const costInvoiceManageUser = 'crm.costInvoice.manage.user'

/**
 * 费用单--提交审批
 */
export const costInvoiceReview = 'crm.costInvoice.review'

/**
 * 费用单--删除
 */
export const costInvoiceRemove = 'crm.costInvoice.remove'

/**
 * 费用单--下载
 */
export const costInvoiceDownload = 'crm.costInvoice.download'

/**
 * 费用单--导入
 */
export const costInvoiceBatch_import = 'crm.costInvoice.batch_import'

/**
 * AI模块
 */
export const functionalAi = 'crm.functional.ai'

/**
 * 小满AI--小满AI
 */
export const aiUser = 'crm.ai.user'

/**
 * 小满AI--创建线索
 */
export const aiLeadCreate = 'crm.ai.lead.create'

/**
 * 物流运输
 */
export const functionalTransport = 'crm.functional.transport'

/**
 * 物流运输--查看
 */
export const transportView = 'crm.transport.view'

/**
 * 跟进动态
 */
export const functionalFollowup = 'crm.functional.followup'

/**
 * 跟进动态--查看
 */
export const followupView = 'crm.followup.view'

/**
 * crm.functional.work.journal
 */
export const functionalWorkJournal = 'crm.functional.work.journal'

/**
 * 工作报告--查看工作报告
 */
export const workJournalView = 'crm.work.journal.view'

/**
 * 工作报告--设置工作报告模板
 */
export const workJournalTemplateSetting = 'crm.work.journal.template.setting'

/**
 * 工作报告--编辑工作报告
 */
export const workJournalEdit = 'crm.work.journal.edit'

/**
 * 工作报告--删除工作报告
 */
export const workJournalDelete = 'crm.work.journal.delete'

/**
 * 营销云基础模块
 */
export const mktFunctionalBase = 'mkt.functional.base'

/**
 * 概况-访客统计-查看
 */
export const mktSiteStatisticView = 'mkt.site.statistic.view'

/**
 * 概况-访客统计-导出数据
 */
export const mktSiteStatisticExport = 'mkt.site.statistic.export'

/**
 * 概况-小工具-查看
 */
export const mktSiteMonitorView = 'mkt.site.monitor.view'

/**
 * 系统设置-网站追踪设置-编辑
 */
export const mktSettingSiteTrack = 'mkt.setting.site.track'

/**
 * 系统设置-角色权限-编辑
 */
export const mktSettingRoleManage = 'mkt.setting.role.manage'

/**
 * 系统设置-自定义表单设置-编辑
 */
export const mktSettingCustomFormSetting = 'mkt.setting.custom.form.setting'

/**
 * 系统设置-多语种设置-编辑
 */
export const mktSettingI18n = 'mkt.setting.i18n'

/**
 * 互动询盘
 */
export const mktFunctionalInquiry = 'mkt.functional.inquiry'

/**
 * 询盘-询盘管理-查看
 */
export const mktInquiryView = 'mkt.inquiry.view'

/**
 * 询盘-询盘管理-删除
 */
export const mktInquiryDelete = 'mkt.inquiry.delete'

/**
 * 询盘-询盘报告-查看
 */
export const mktInquiryReportView = 'mkt.inquiry.report.view'

/**
 * 询盘-询盘报告-导出报告
 */
export const mktInquiryReportExport = 'mkt.inquiry.report.export'

/**
 * 询盘-询盘设置-编辑
 */
export const mktSiteManageNotification = 'mkt.site.manage.notification'

/**
 * 询盘-回收箱-编辑
 */
export const mktInquiryRecycle = 'mkt.inquiry.recycle'

/**
 * 在线客服
 */
export const mktFunctionalConversation = 'mkt.functional.conversation'

/**
 * 会话-历史会话-查看
 */
export const mktConversationHistoryView = 'mkt.conversation.history.view'

/**
 * 会话-会话设置-查看
 */
export const mktConversationSettingView = 'mkt.conversation.setting.view'

/**
 * 会话-会话设置-创建
 */
export const mktConversationSettingCreate = 'mkt.conversation.setting.create'

/**
 * 会话-会话设置-编辑
 */
export const mktConversationSettingEdit = 'mkt.conversation.setting.edit'

/**
 * 会话-会话设置-删除
 */
export const mktConversationSettingDelete = 'mkt.conversation.setting.delete'

/**
 * google ads 营销
 */
export const functionalAds = 'crm.functional.ads'

/**
 * 谷歌广告-广告报告-查看
 */
export const mktGoogleAdsView = 'mkt.google.ads.view'

/**
 * 谷歌广告-广告报告-导出数据
 */
export const mktGoogleAdsExport = 'mkt.google.ads.export'

/**
 * 谷歌广告-广告账户管理,广告账户设置-编辑
 */
export const mktSettingGoogleAdsAccount = 'mkt.setting.google.ads.account'

/**
 * 谷歌广告-广告账户管理,广告追踪设置-编辑
 */
export const mktSettingGoogleAdsTrack = 'mkt.setting.google.ads.track'

/**
 * 内容
 */
export const mktFunctionalContent = 'mkt.functional.content'

/**
 * 网站内容-产品,产品管理-查看
 */
export const mktProductView = 'mkt.product.view'

/**
 * 网站内容-产品,产品管理-创建
 */
export const mktProductCreate = 'mkt.product.create'

/**
 * 网站内容-产品,产品管理-编辑
 */
export const mktProductEdit = 'mkt.product.edit'

/**
 * 网站内容-产品,产品管理-删除
 */
export const mktProductDelete = 'mkt.product.delete'

/**
 * 网站内容-产品,产品分组-编辑
 */
export const mktProductGroup = 'mkt.product.group'

/**
 * 网站内容-产品,产品设置-编辑
 */
export const mktProductSetting = 'mkt.product.setting'

/**
 * 网站内容-产品,产品同步-编辑
 */
export const mktProductSyncing = 'mkt.product.syncing'

/**
 * 网站内容-文章,文章管理-查看
 */
export const mktArticleView = 'mkt.article.view'

/**
 * 网站内容-文章,文章管理-创建
 */
export const mktArticleCreate = 'mkt.article.create'

/**
 * 网站内容-文章,文章管理-编辑
 */
export const mktArticleEdit = 'mkt.article.edit'

/**
 * 网站内容-文章,文章管理-删除
 */
export const mktArticleDelete = 'mkt.article.delete'

/**
 * 网站内容-文章,文章分组-编辑
 */
export const mktArticleGroup = 'mkt.article.group'

/**
 * 网站内容-图集,图集管理-查看
 */
export const mktImage_collectionView = 'mkt.image_collection.view'

/**
 * 网站内容-图集,图集管理-创建
 */
export const mktImage_collectionCreate = 'mkt.image_collection.create'

/**
 * 网站内容-图集,图集管理-编辑
 */
export const mktImage_collectionEdit = 'mkt.image_collection.edit'

/**
 * 网站内容-图集,图集管理-删除
 */
export const mktImage_collectionDelete = 'mkt.image_collection.delete'

/**
 * 网站内容-图集,图集分组-编辑
 */
export const mktImage_collectionGroup = 'mkt.image_collection.group'

/**
 * 网站内容-视频-查看
 */
export const mktVideoView = 'mkt.video.view'

/**
 * 网站内容-视频-创建
 */
export const mktVideoCreate = 'mkt.video.create'

/**
 * 网站内容-视频-编辑
 */
export const mktVideoEdit = 'mkt.video.edit'

/**
 * 网站内容-视频-删除
 */
export const mktVideoDelete = 'mkt.video.delete'

/**
 * 网站内容-下载-查看
 */
export const mktDownloadView = 'mkt.download.view'

/**
 * 网站内容-下载-创建
 */
export const mktDownloadCreate = 'mkt.download.create'

/**
 * 网站内容-下载-编辑
 */
export const mktDownloadEdit = 'mkt.download.edit'

/**
 * 网站内容-下载-删除
 */
export const mktDownloadDelete = 'mkt.download.delete'

/**
 * 网站内容-回收箱-编辑
 */
export const mktSettingRecycle = 'mkt.setting.recycle'

/**
 * 建站
 */
export const mktFunctionalSite = 'mkt.functional.site'

/**
 * 网站设置-网站模板-编辑
 */
export const mktSiteManageTemplate = 'mkt.site.manage.template'

/**
 * 网站设置-网站栏目-编辑
 */
export const mktSiteManageSection = 'mkt.site.manage.section'

/**
 * 网站设置-网站首页-编辑
 */
export const mktSiteManageIndex = 'mkt.site.manage.index'

/**
 * 网站设置-表单管理-查看
 */
export const mktFormView = 'mkt.form.view'

/**
 * 网站设置-表单管理-创建
 */
export const mktFormCreate = 'mkt.form.create'

/**
 * 网站设置-表单管理-编辑
 */
export const mktFormEdit = 'mkt.form.edit'

/**
 * 网站设置-表单管理-删除
 */
export const mktFormDelete = 'mkt.form.delete'

/**
 * 网站设置-订阅管理-查看
 */
export const mktSubscriptionView = 'mkt.subscription.view'

/**
 * 网站设置-订阅管理-编辑
 */
export const mktSubscriptionEdit = 'mkt.subscription.edit'

/**
 * 网站设置-网站管理-发布网站
 */
export const mktSiteManageDeploy = 'mkt.site.manage.deploy'

/**
 * 网站设置-网站信息-编辑
 */
export const mktSiteManageInfo = 'mkt.site.manage.info'

/**
 * 网站设置-网站域名-编辑
 */
export const mktSiteManageDomain = 'mkt.site.manage.domain'

/**
 * 网站设置-网站语言-编辑
 */
export const mktSiteManageLanguage = 'mkt.site.manage.language'

/**
 * 网站设置-站点管理-查看
 */
export const mktSiteManageView = 'mkt.site.manage.view'

/**
 * 网站设置-站点管理-编辑
 */
export const mktSiteManageEdit = 'mkt.site.manage.edit'

/**
 * 网站设置-操作记录-查看
 */
export const mktSettingOperateRecord = 'mkt.setting.operate.record'

/**
 * 后台管理
 */
export const functionalBoss = 'crm.functional.boss'

/**
 * crm.functional.socialmedia
 */
export const functionalSocialmedia = 'crm.functional.socialmedia'

/**
 * dx.functional.base
 */
export const dxFunctionalBase = 'dx.functional.base'

/**
 * dx.functional.google
 */
export const dxFunctionalGoogle = 'dx.functional.google'

/**
 * dx.functional.facebook.search
 */
export const dxFunctionalFacebookSearch = 'dx.functional.facebook.search'

/**
 * dx.functional.facebook.monitor
 */
export const dxFunctionalFacebookMonitor = 'dx.functional.facebook.monitor'

/**
 * dx.functional.linkedin.search
 */
export const dxFunctionalLinkedinSearch = 'dx.functional.linkedin.search'

/**
 * crm.functional.setting.customer
 */
export const functionalSettingCustomer = 'crm.functional.setting.customer'

/**
 * crm.functional.setting.customer.manage
 */
export const functionalSettingCustomerManage =
  'crm.functional.setting.customer.manage'

/**
 * 订单工具
 */
export const functionalBillQuote = 'crm.functional.bill.quote'

/**
 * 添加账号
 */
export const functionalAccountAdd = 'crm.functional.account.add'

/**
 * 商机自动化
 */
export const functionalAiClassifyOpportunity =
  'crm.functional.ai.classify.opportunity'

/**
 * 客户自动化&&邮件自动化
 */
export const functionalAiClassifyCustomer =
  'crm.functional.ai.classify.customer'

/**
 * 业绩团队墙模块
 */
export const functionalPerformanceTeamWall =
  'crm.functional.performance.team.wall'

/**
 * crm.functional.performance.target.show
 */
export const functionalPerformanceTargetShow =
  'crm.functional.performance.target.show'

/**
 * crm.functional.performance.target.import
 */
export const functionalPerformanceTargetImport =
  'crm.functional.performance.target.import'

/**
 * AI 仪表盘
 */
export const functionalAiDashboard = 'crm.functional.ai.dashboard'

/**
 * AI 推荐
 */
export const functionalAiRecommend = 'crm.functional.ai.recommend'

/**
 * AI 客户即将移入公海
 */
export const functionalAiMovePool = 'crm.functional.ai.move.pool'

/**
 * AI 客户海关数据更新
 */
export const functionalAiCiq = 'crm.functional.ai.ciq'

/**
 * AI 跟进客户
 */
export const functionalAiFollowCustomer = 'crm.functional.ai.follow.customer'

/**
 * AI 开发新线索
 */
export const functionalAiDevelopLead = 'crm.functional.ai.develop.lead'

/**
 * AI 跟进线索
 */
export const functionalAiFollowLead = 'crm.functional.ai.follow.lead'

/**
 * AI 邮件自动分类
 */
export const functionalAiClassifyEmail = 'crm.functional.ai.classify.email'

/**
 * 客户建档完成后推荐
 */
export const functionalAiRecommendAfterArchive =
  'crm.functional.ai.recommend.after.archive'

/**
 * 邮件发送后推荐
 */
export const functionalAiRecommendAfterSend =
  'crm.functional.ai.recommend.after.send'

/**
 * 线索导出
 */
export const functionalLeadReport = 'crm.functional.lead.report'

/**
 * 线索创建
 */
export const functionalLeadUserCreate = 'crm.functional.lead.user.create'

/**
 * 线索状态
 */
export const functionalLeadStatus = 'crm.functional.lead.status'

/**
 * 客户公海分组
 */
export const functionalCompanyPoolSetting =
  'crm.functional.company.pool.setting'

/**
 * 自动移入公海规则
 */
export const functionalCompanyPoolAutoRules =
  'crm.functional.company.pool.auto.rules'

/**
 * 订单导出模板
 */
export const functionalOrderExportTemplate =
  'crm.functional.order.export.template'

/**
 * 商机高级设置
 */
export const functionalOpportunityAdvancedSetting =
  'crm.functional.opportunity.advanced.setting'

/**
 * 商机高级统计
 */
export const functionalOpportunityAdvancedStatistics =
  'crm.functional.opportunity.advanced.statistics'

/**
 * 审批模块
 */
export const functionalReviewBase = 'crm.functional.review.base'

/**
 * DX 我的关注
 */
export const functionalDxFollow = 'crm.functional.dx.follow'

/**
 * DX 产品搜索
 */
export const functionalDxProductSearch = 'crm.functional.dx.product.search'

/**
 * 公司搜索
 */
export const functionalDxCompanySearch = 'crm.functional.dx.company.search'

/**
 * DX 发掘
 */
export const functionalDxMining = 'crm.functional.dx.mining'

/**
 * MK 基础功能
 */
export const functionalMkBase = 'crm.functional.mk.base'

/**
 * 商机自动化编辑设置
 */
export const functionalAiClassifyOpportunitySettingEdit =
  'crm.functional.ai.classify.opportunity.setting.edit'

/**
 * 海关数据3.0
 */
export const functionalCiq = 'crm.functional.ciq'

/**
 * 旧版邮件
 */
export const functionalMailV1 = 'crm.functional.mail.v1'

/**
 * 自定义销售订单统计口径
 */
export const functionalPerformanceOrderCustomField =
  'crm.functional.performance.order.custom.field'

/**
 * 销售管理
 */
export const functionalSalesManagement = 'crm.functional.sales.management'

/**
 * paypal模块
 */
export const functionalPaypal = 'crm.functional.paypal'

/**
 * 工作台
 */
export const functionalWorkbench = 'crm.functional.workbench'

/**
 * 销售管理的组织架构
 */
export const functionalStructure = 'crm.functional.structure'

/**
 * 线索自动化
 */
export const functionalAiClassifyLead = 'crm.functional.ai.classify.lead'

/**
 * DX 小满助手
 */
export const functionalDxAssistant = 'crm.functional.dx.assistant'

/**
 * crm.functional.edm.mailgun
 */
export const functionalEdmMailgun = 'crm.functional.edm.mailgun'

/**
 * 商机销售流程
 */
export const functionalOpportunitySalesFlow =
  'crm.functional.opportunity.sales.flow'

/**
 * 商机审批
 */
export const functionalOpportunityReview = 'crm.functional.opportunity.review'

/**
 * AI开发信产品
 */
export const functionalAiProduct = 'crm.functional.ai.product'

/**
 * DX关注公司动态
 */
export const functionalDxFocusCompanyDynamic =
  'crm.functional.dx.focus.company.dynamic'

/**
 * 员工搜索
 */
export const functionalEmployeesSearch = 'crm.functional.employees.search'

/**
 * 线索搜索
 */
export const functionalLeadSearch = 'crm.functional.lead.search'

/**
 * 产品自动化
 */
export const functionalAiClassifyProduct = 'crm.functional.ai.classify.product'

/**
 * OKKI-API（CRM/Plus/Lite/Smart/Pro）
 */
export const functionalOkki = 'crm.functional.okki'

/**
 * DX 定制推荐
 */
export const functionalDxRecommended = 'crm.functional.dx.recommended'

/**
 * DX 订阅
 */
export const functionalDxSubscription = 'crm.functional.dx.subscription'

/**
 * DX 海关数据3.0
 */
export const functionalDxCiq = 'crm.functional.dx.ciq'

/**
 * 统计分析模块-企业报表自定义
 */
export const functionalStatisticReportCustom =
  'crm.functional.statistic.report.custom'

/**
 * 统计分析模块-看板自定义
 */
export const functionalStatisticDashboardCustom =
  'crm.functional.statistic.dashboard.custom'

/**
 * 统计分析模块-员工报表自定义
 */
export const functionalStatisticReportUserCustom =
  'crm.functional.statistic.report.user.custom'

/**
 * 工作流
 */
export const functionalWorkflow = 'crm.functional.workflow'

/**
 * 统计分析-报表快照
 */
export const functionalStatisticReportSnapshot =
  'crm.functional.statistic.report.snapshot'

/**
 * 统计分析-报表快照
 */
export const functionalStatisticReportSubscribe =
  'crm.functional.statistic.report.subscribe'

/**
 * marketing 自动化
 */
export const functionalMkAuto = 'crm.functional.mk.auto'

/**
 * 审批流
 */
export const functionalApprovalflow = 'crm.functional.approvalflow'

/**
 * 统计分析-跟进人
 */
export const functionalStatisticFollowUp = 'crm.functional.statistic.follow.up'

/**
 * 阿里询盘
 */
export const functionalAlibabaTrade = 'crm.functional.alibaba.trade'

/**
 * 营销 - 社交托管
 */
export const functionalSnsAccount = 'crm.functional.sns.account'

/**
 * 阿里圈战活动，指定clientId添加
 */
export const functionalAliSalesRace = 'crm.functional.ali.sales.race'

/**
 * 关闭所有审批权限
 */
export const functionalDisableApproval = 'crm.functional.disable.approval'

/**
 * 在线课程
 */
export const functionalOnlineCourses = 'crm.functional.online.courses'

/**
 * 采购模块
 */
export const functionalPurchase = 'crm.functional.purchase'

/**
 * 试用
 */
export const functionalPurchaseTrial = 'crm.functional.purchase.trial'

/**
 * 新版工作台
 */
export const functionalWorkbenchV2 = 'crm.functional.workbench.v2'

/**
 * crm.functional.facebook
 */
export const functionalFacebook = 'crm.functional.facebook'

/**
 * crm.functional.facebooklead
 */
export const functionalFacebooklead = 'crm.functional.facebooklead'

/**
 * crm.functional.waba
 */
export const functionalWaba = 'crm.functional.waba'

/**
 * crm.functional.custom.login_page
 */
export const functionalCustomLogin_page = 'crm.functional.custom.login_page'

/**
 * crm.functional.assistant.tm
 */
export const functionalAssistantTm = 'crm.functional.assistant.tm'

/**
 * crm.functional.visitor.marketing
 */
export const functionalVisitorMarketing = 'crm.functional.visitor.marketing'

/**
 * crm.functional.opportunity.new.dynamic
 */
export const functionalOpportunityNewDynamic =
  'crm.functional.opportunity.new.dynamic'

/**
 * crm.functional.assistant.background
 */
export const functionalAssistantBackground =
  'crm.functional.assistant.background'

/**
 * crm.functional.assistant.sales.guide
 */
export const functionalAssistantSalesGuide =
  'crm.functional.assistant.sales.guide'

/**
 * crm.functional.ames
 */
export const functionalAmes = 'crm.functional.ames'

/**
 * crm.functional.schedule
 */
export const functionalSchedule = 'crm.functional.schedule'

/**
 * crm.functional.schedule.senior
 */
export const functionalScheduleSenior = 'crm.functional.schedule.senior'

/**
 * crm.functional.schedule.mail.create
 */
export const functionalScheduleMailCreate =
  'crm.functional.schedule.mail.create'

/**
 * crm.functional.schedule.company.create
 */
export const functionalScheduleCompanyCreate =
  'crm.functional.schedule.company.create'

/**
 * crm.functional.mail.template.enterprise
 */
export const functionalMailTemplateEnterprise =
  'crm.functional.mail.template.enterprise'

/**
 * crm.functional.mail.company
 */
export const functionalMailCompany = 'crm.functional.mail.company'

/**
 * crm.functional.mail.subordinate
 */
export const functionalMailSubordinate = 'crm.functional.mail.subordinate'

/**
 * crm.functional.mail.review
 */
export const functionalMailReview = 'crm.functional.mail.review'

/**
 * crm.functional.mail.distribute
 */
export const functionalMailDistribute = 'crm.functional.mail.distribute'

/**
 * crm.functional.setting.email.manage
 */
export const functionalSettingEmailManage =
  'crm.functional.setting.email.manage'

/**
 * crm.functional.notice.mail.conflict
 */
export const functionalNoticeMailConflict =
  'crm.functional.notice.mail.conflict'

/**
 * crm.functional.mail.trace
 */
export const functionalMailTrace = 'crm.functional.mail.trace'

/**
 * crm.functional.notice
 */
export const functionalNotice = 'crm.functional.notice'

/**
 * crm.functional.risk
 */
export const functionalRisk = 'crm.functional.risk'

/**
 * crm.functional.notice.desktop.senior
 */
export const functionalNoticeDesktopSenior =
  'crm.functional.notice.desktop.senior'

/**
 * crm.functional.notice.browser.senior
 */
export const functionalNoticeBrowserSenior =
  'crm.functional.notice.browser.senior'

/**
 * crm.functional.notice.message.ames
 */
export const functionalNoticeMessageAmes = 'crm.functional.notice.message.ames'

/**
 * crm.functional.disk
 */
export const functionalDisk = 'crm.functional.disk'

/**
 * crm.functional.contacts
 */
export const functionalContacts = 'crm.functional.contacts'

/**
 * crm.functional.dx.similar.company
 */
export const functionalDxSimilarCompany = 'crm.functional.dx.similar.company'

/**
 * crm.functional.recycle
 */
export const functionalRecycle = 'crm.functional.recycle'

/**
 * crm.functional.ai.setting
 */
export const functionalAiSetting = 'crm.functional.ai.setting'

/**
 * crm.functional.department
 */
export const functionalDepartment = 'crm.functional.department'

/**
 * crm.functional.task
 */
export const functionalTask = 'crm.functional.task'

/**
 * crm.functional.member.manage
 */
export const functionalMemberManage = 'crm.functional.member.manage'

/**
 * crm.functional.account.manage
 */
export const functionalAccountManage = 'crm.functional.account.manage'

/**
 * crm.functional.role.manage
 */
export const functionalRoleManage = 'crm.functional.role.manage'

/**
 * crm.functional.customize.field
 */
export const functionalCustomizeField = 'crm.functional.customize.field'

/**
 * crm.functional.inquiry
 */
export const functionalInquiry = 'crm.functional.inquiry'

/**
 * crm.functional.company.info.senior
 */
export const functionalCompanyInfoSenior = 'crm.functional.company.info.senior'

/**
 * crm.functional.company.duplication.check
 */
export const functionalCompanyDuplicationCheck =
  'crm.functional.company.duplication.check'

/**
 * crm.functional.company.export
 */
export const functionalCompanyExport = 'crm.functional.company.export'

/**
 * crm.functional.company.manage.user
 */
export const functionalCompanyManageUser = 'crm.functional.company.manage.user'

/**
 * crm.functional.followup.next.follow.time
 */
export const functionalFollowupNextFollowTime =
  'crm.functional.followup.next.follow.time'

/**
 * crm.functional.company.group
 */
export const functionalCompanyGroup = 'crm.functional.company.group'

/**
 * crm.functional.company.dx.match
 */
export const functionalCompanyDxMatch = 'crm.functional.company.dx.match'

/**
 * crm.functional.company.global.trade.archive
 */
export const functionalCompanyGlobalTradeArchive =
  'crm.functional.company.global.trade.archive'

/**
 * crm.functional.edm
 */
export const functionalEdm = 'crm.functional.edm'

/**
 * crm.functional.ai.classify.mail
 */
export const functionalAiClassifyMail = 'crm.functional.ai.classify.mail'

/**
 * crm.functional.company.swarm.recommend
 */
export const functionalCompanySwarmRecommend =
  'crm.functional.company.swarm.recommend'

/**
 * crm.functional.company.swarm.scope
 */
export const functionalCompanySwarmScope = 'crm.functional.company.swarm.scope'

/**
 * crm.functional.user.guide
 */
export const functionalUserGuide = 'crm.functional.user.guide'

/**
 * crm.functional.whatsapp
 */
export const functionalWhatsapp = 'crm.functional.whatsapp'

/**
 * crm.functional.whatsapp.chat.group
 */
export const functionalWhatsappChatGroup = 'crm.functional.whatsapp.chat.group'

/**
 * crm.functional.leads.menu.v2
 */
export const functionalLeadsMenuV2 = 'crm.functional.leads.menu.v2'

/**
 * crm.functional.company.remove
 */
export const functionalCompanyRemove = 'crm.functional.company.remove'

/**
 * crm.functional.ai.tag.mark
 */
export const functionalAiTagMark = 'crm.functional.ai.tag.mark'

/**
 * crm.functional.exchange
 */
export const functionalExchange = 'crm.functional.exchange'

/**
 * crm.functional.capital_account
 */
export const functionalCapital_account = 'crm.functional.capital_account'

/**
 * crm.functional.warehouse
 */
export const functionalWarehouse = 'crm.functional.warehouse'

/**
 * crm.functional.invoice.template
 */
export const functionalInvoiceTemplate = 'crm.functional.invoice.template'

/**
 * crm.functional.fund
 */
export const functionalFund = 'crm.functional.fund'

/**
 * Alibaba.com Pay 模块
 */
export const functionalAcp = 'crm.functional.acp'

/**
 * 产品
 */
export const mktFunctionalProduct = 'mkt.functional.product'

/**
 * 建站
 */
export const mktFunctionalSiteCustom = 'mkt.functional.site.custom'

/**
 * 广告追踪
 */
export const mktFunctionalAdsTrack = 'mkt.functional.ads.track'

/**
 * 表单
 */
export const mktFunctionalForm = 'mkt.functional.form'

/**
 * 概览
 */
export const mktFunctionalOverview = 'mkt.functional.overview'

/**
 * 订阅
 */
export const mktFunctionalSubscribe = 'mkt.functional.subscribe'

/**
 * 表单
 */
export const mktFunctionalCustomForm = 'mkt.functional.custom.form'

/**
 * mkt.functional.i18n
 */
export const mktFunctionalI18n = 'mkt.functional.i18n'

/**
 * shop.functional.base
 */
export const shopFunctionalBase = 'shop.functional.base'

/**
 * crm.admin
 */
export const crmAdmin = 'crm.admin'

/**
 * crm.user
 */
export const crmUser = 'crm.user'

/**
 * crm.call.subordinate
 */
export const callSubordinate = 'crm.call.subordinate'

/**
 * 二次权限，查看商机
 */
export const secondaryOpportunityView = 'crm.secondary.opportunity.view'

/**
 * 二次权限，添加商机动态
 */
export const secondaryOpportunityTrailCreate =
  'crm.secondary.opportunity.trail.create'

/**
 * 二次权限，编辑商机
 */
export const secondaryOpportunityEdit = 'crm.secondary.opportunity.edit'

/**
 * crm.dx.admin
 */
export const dxAdmin = 'crm.dx.admin'

/**
 * crm.custom.login_page.manage
 */
export const customLogin_pageManage = 'crm.custom.login_page.manage'
